import React from "react";
import { ClockCircleOutlined, CheckOutlined } from "@ant-design/icons";

const CountdownTimer = ({
  minutes,
  seconds,
  recording,
  countdownFinished,
  videoDuration = 0,
}) => {
  const getColors = () => {
    if (recording) {
      return {
        border: "#597EF7",
        text: "#597EF7",
        icon: "#597EF7",
      };
    } else if (countdownFinished) {
      return {
        border: "#52C41A",
        text: "#52C41A",
        icon: "#52C41A",
      };
    }
    return {
      border: "#D9D9D9",
      text: "inherit",
      icon: "#8b2c1f",
    };
  };

  const colors = getColors();

  // Cuando el video está listo para ver, mostrar la duración del video
  const displayTime =
    countdownFinished && !recording
      ? {
          minutes: Math.floor(videoDuration / 60),
          seconds: videoDuration % 60,
        }
      : { minutes, seconds };

  return (
    <div
      style={{
        border: `1px solid ${colors.border}`,
        borderRadius: "8px",
        padding: "8px 16px",
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        gap: 6,
      }}
    >
      {countdownFinished && !recording ? (
        <CheckOutlined
          style={{
            color: colors.icon,
            fontSize: 16,
          }}
        />
      ) : (
        <ClockCircleOutlined
          style={{
            color: colors.icon,
            fontSize: 16,
          }}
        />
      )}
      <span
        style={{
          fontWeight: 600,
          color: colors.text,
        }}
      >
        {`${displayTime.minutes}:${("0" + displayTime.seconds).slice(-2)}`}
      </span>
    </div>
  );
};

export default CountdownTimer;
